/**
 * exportCsv.js - browser downloads: one "save this blob as a file"
 * (downloadBlob) and exportCsv for an array of objects. The chat's table
 * export, the quote builder's documents and the tables' Excel export use the
 * same download. The cell rules are utils/csv.js (tests mock this module).
 */
import { csvCell } from './csv';

/** Hand a blob to the browser as a download (the URL is freed once the click has it). */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export function exportCsv(filename, rows) {
  if (!rows || rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const csv = [headers.map(csvCell).join(','), ...rows.map((row) => headers.map((h) => csvCell(row[h])).join(','))].join('\n');
  downloadBlob(new Blob([csv], { type: 'text/csv;charset=utf-8;' }), filename);
}
